/**
 * <dream-cart-extras>
 * Módulo inline de frete + cupom (Horizon / Checkout style).
 * - CEP→UF automático, polling, auto-seleciona melhor opção
 * - Cupom com validação real + atualiza subtotal/desconto no footer
 * - Mostra cupons já aplicados no carrinho (discount_codes) com botão remover
 * - Persiste via sessionStorage, reage a eventos de cart update
 */
class DreamCartExtras extends HTMLElement {
  connectedCallback() {
    this._pollId = 0; /* abort de polls anteriores */

    this.shippingBtn    = this.querySelector('[data-shipping-calc]');
    this.shippingZip    = this.querySelector('[data-shipping-zip]');
    this.shippingResult = this.querySelector('[data-shipping-result]');

    this.couponBtn    = this.querySelector('[data-coupon-apply]');
    this.couponInput  = this.querySelector('[data-coupon-input]');
    this.couponResult = this.querySelector('[data-coupon-result]');

    if (this.shippingBtn) {
      this._shipLabel = this.shippingBtn.textContent.trim();
      this.shippingBtn.addEventListener('click', this.calcShipping.bind(this));
      this.shippingZip.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); this.calcShipping(); }
      }.bind(this));
      this.shippingZip.addEventListener('input', this.maskCep.bind(this));
    }

    if (this.couponBtn) {
      this._cpnLabel = this.couponBtn.textContent.trim();
      this.couponBtn.addEventListener('click', this.applyCoupon.bind(this));
      this.couponInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); this.applyCoupon(); }
      }.bind(this));
    }

    /* Restaurar estado salvo (sobrevive AJAX re-render) */
    this.restoreState();

    /* Escutar evento de atualização do carrinho */
    this._onCartUpdate = this.onCartUpdate.bind(this);
    document.addEventListener('dream:cart:updated', this._onCartUpdate);
  }

  disconnectedCallback() {
    document.removeEventListener('dream:cart:updated', this._onCartUpdate);
  }

  /* ═══ Persistência ═══ */

  saveShipping(zip, rate) {
    try {
      sessionStorage.setItem('dream_ship', JSON.stringify({ zip: zip, rate: rate }));
    } catch (e) { /* quota */ }
  }

  saveCoupon(code) {
    try {
      sessionStorage.setItem('dream_coupon', code);
    } catch (e) {}
  }

  restoreState() {
    /* Frete */
    try {
      var ship = JSON.parse(sessionStorage.getItem('dream_ship'));
      if (ship && ship.zip && ship.rate && this.shippingZip) {
        this.shippingZip.value = this.formatCep(ship.zip);
        this.renderRate(ship.rate);
        var details = this.querySelector('[data-shipping-calc]');
        if (details) details.closest('details').setAttribute('open', '');
      }
    } catch (e) {}

    /* Cupom — lê direto do cart */
    this.refreshCouponFromCart();
  }

  refreshCouponFromCart() {
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        self.syncFooter(cart);
        self.showAppliedCoupons(cart);
      })
      .catch(function () {});
  }

  onCartUpdate(e) {
    var cart = e.detail && e.detail.cart;
    if (cart) {
      this.syncFooter(cart);
      this.showAppliedCoupons(cart);
    }

    /* Recalcular frete se CEP salvo (carrinho mudou → preço pode mudar) */
    try {
      var ship = JSON.parse(sessionStorage.getItem('dream_ship'));
      if (ship && ship.zip) {
        var uf = DreamCartExtras.cepToUF(ship.zip);
        if (uf) this.pollRates(ship.zip, uf, 0, true);
      }
    } catch (e) {}
  }

  /* ═══ CEP mask / format ═══ */
  maskCep() {
    var v = this.shippingZip.value.replace(/\D/g, '').slice(0, 8);
    if (v.length > 5) v = v.slice(0, 5) + '-' + v.slice(5);
    this.shippingZip.value = v;
  }

  formatCep(zip) {
    var v = String(zip).replace(/\D/g, '').slice(0, 8);
    return v.length > 5 ? v.slice(0, 5) + '-' + v.slice(5) : v;
  }

  /* ═══ CEP → UF ═══ */
  static cepToUF(cep) {
    var n = parseInt(String(cep).replace(/\D/g, '').substring(0, 5), 10);
    var ranges = [
      [1000,  19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'],
      [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
      [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'],
      [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
      [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
      [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
      [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'],
      [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 77999, 'TO'],
      [78000, 78899, 'MT'], [78900, 78999, 'RO'], [79000, 79999, 'MS'],
      [80000, 87999, 'PR'], [88000, 89999, 'SC'], [90000, 99999, 'RS']
    ];
    for (var i = 0; i < ranges.length; i++) {
      if (n >= ranges[i][0] && n <= ranges[i][1]) return ranges[i][2];
    }
    return null;
  }

  /* ═══ FRETE ═══ */
  calcShipping() {
    var zip = (this.shippingZip.value || '').replace(/\D/g, '');
    if (zip.length < 8) {
      this.showResult(this.shippingResult, 'Digite um CEP válido (8 dígitos).', 'error');
      return;
    }
    var uf = DreamCartExtras.cepToUF(zip);
    if (!uf) {
      this.showResult(this.shippingResult, 'CEP não reconhecido.', 'error');
      return;
    }
    /* Invalidar poll anterior + salvar CEP imediatamente para evitar race condition */
    this._pollId++;
    try { sessionStorage.setItem('dream_ship', JSON.stringify({ zip: zip, rate: null })); } catch (e) {}
    this.setLoading(this.shippingBtn, true);
    this.shippingResult.hidden = true;
    this.pollRates(zip, uf, 0, false, this._pollId);
  }

  pollRates(zip, uf, attempt, silent, pollId) {
    var self = this;
    var MAX = 8;
    var DELAY = 1200;

    /* Se o pollId não bate, um cálculo mais recente foi iniciado — abortar */
    if (pollId !== undefined && pollId !== self._pollId) return;

    var url = '/cart/shipping_rates.json' +
      '?shipping_address[zip]=' + encodeURIComponent(zip) +
      '&shipping_address[country]=BR' +
      '&shipping_address[province]=' + encodeURIComponent(uf);

    fetch(url)
      .then(function (r) {
        if (pollId !== undefined && pollId !== self._pollId) return null;
        if (r.status === 422) {
          if (attempt < MAX) {
            setTimeout(function () { self.pollRates(zip, uf, attempt + 1, silent, pollId); }, DELAY);
            return null;
          }
          if (!silent) {
            return r.json().then(function (err) {
              var msgs = [];
              if (err && typeof err === 'object') {
                Object.keys(err).forEach(function (k) {
                  var v = err[k];
                  if (Array.isArray(v)) msgs = msgs.concat(v);
                  else if (typeof v === 'string') msgs.push(v);
                });
              }
              self.showResult(
                self.shippingResult,
                msgs.length ? msgs.join('. ') : 'Não foi possível calcular frete para este CEP.',
                'error'
              );
              self.setLoading(self.shippingBtn, false, self._shipLabel);
              return null;
            });
          }
          return null;
        }
        if (!r.ok) throw new Error(r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data) return;
        if (pollId !== undefined && pollId !== self._pollId) return;

        var rates = data.shipping_rates || [];
        if (!rates.length) {
          if (!silent) {
            self.showResult(self.shippingResult, 'Nenhuma opção de entrega para este CEP.', 'error');
          }
          self.setLoading(self.shippingBtn, false, self._shipLabel);
          return;
        }

        /* Selecionar a melhor opção: menor preço (grátis > barato) */
        rates.sort(function (a, b) { return parseFloat(a.price) - parseFloat(b.price); });
        var best = rates[0];

        self.saveShipping(zip, best);
        self.renderRate(best);
        self.setLoading(self.shippingBtn, false, self._shipLabel);

        /* Atualizar footer com o novo frete */
        self.refreshFooterShipping();
      })
      .catch(function () {
        if (pollId !== undefined && pollId !== self._pollId) return;
        if (!silent) {
          self.showResult(self.shippingResult, 'Erro de conexão. Tente novamente.', 'error');
        }
        self.setLoading(self.shippingBtn, false, self._shipLabel);
      });
  }

  refreshFooterShipping() {
    var footer = document.querySelector('[data-cart-drawer-footer]');
    if (!footer) return;
    var shippingRow = footer.querySelector('.cart-drawer__shipping-row');
    var shippingEl = footer.querySelector('[data-cart-shipping]');
    if (!shippingRow) return;
    try {
      var ship = JSON.parse(sessionStorage.getItem('dream_ship'));
      if (ship && ship.rate) {
        shippingRow.hidden = false;
        var p = parseFloat(ship.rate.price);
        if (shippingEl) {
          shippingEl.innerHTML = p === 0
            ? '<span class="cart-extras__tag-free">Grátis</span>'
            : this.fmtMoney(Math.round(p * 100));
        }
      } else {
        shippingRow.hidden = true;
      }
    } catch (e) {
      shippingRow.hidden = true;
    }

    /* Recalcular o total exibido (cart total + frete) */
    var totalEl = footer.querySelector('[data-cart-total]');
    if (totalEl) {
      var cartTotal = parseInt(totalEl.getAttribute('data-cart-total-cents') || '0', 10);
      totalEl.innerHTML = this.fmtMoney(cartTotal + this.getShippingCents());
    }
  }

  getShippingCents() {
    try {
      var ship = JSON.parse(sessionStorage.getItem('dream_ship'));
      if (ship && ship.rate) return Math.round(parseFloat(ship.rate.price) * 100);
    } catch (e) {}
    return 0;
  }

  renderRate(rate) {
    var price = parseFloat(rate.price);
    var priceStr = price === 0
      ? '<span class="cart-extras__tag-free">Grátis</span>'
      : this.fmtMoney(Math.round(price * 100));

    var html =
      '<div class="cart-extras__rate cart-extras__rate--selected">' +
        '<span class="cart-extras__rate-name">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg> ' +
          rate.name +
        '</span>' +
        '<span class="cart-extras__rate-price">' + priceStr + '</span>' +
      '</div>';

    this.showResult(this.shippingResult, html, 'success');
  }

  /* ═══ CUPOM ═══ */

  /* Mostra cupons já aplicados no carrinho (discount_codes) */
  showAppliedCoupons(cart) {
    if (!this.couponResult) return;

    /* Se desconto foi marcado como removido localmente, não mostrar */
    if (sessionStorage.getItem('dream_discount_removed') === 'true') {
      this.couponResult.hidden = true;
      return;
    }

    var codes = cart.discount_codes || [];
    var applicable = codes.filter(function (c) { return c.applicable; });
    /* Dedup por código (case-insensitive) */
    var seen = {};
    applicable = applicable.filter(function (c) {
      var key = (c.code || '').toUpperCase();
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
    if (!applicable.length) {
      this.couponResult.hidden = true;
      return;
    }

    /* Não sobrescrever se já há resultado de erro visível */
    if (!this.couponResult.hidden &&
        this.couponResult.classList.contains('cart-extras__result--error')) return;

    var self = this;
    var html = applicable.map(function (c) {
      var apps = cart.cart_level_discount_applications || [];
      var amount = 0;
      for (var i = 0; i < apps.length; i++) {
        if ((apps[i].title || '').toLowerCase() === (c.code || '').toLowerCase()) {
          amount = apps[i].total_allocated_amount || 0;
          break;
        }
      }
      return self.buildCouponTagHtml(c.code, amount);
    }).join('');

    this.showResult(this.couponResult, html, 'success');

    /* Abrir o <details> do cupom */
    var details = this.couponResult.closest('details');
    if (details) details.setAttribute('open', '');
  }

  buildCouponTagHtml(code, amount) {
    var amountStr = amount > 0 ? '<span class="cart-extras__coupon-amount">(-' + this.fmtMoney(amount) + ')</span>' : '';
    return '<div class="cart-extras__coupon-tag">' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
        '<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>' +
        '<line x1="7" y1="7" x2="7.01" y2="7"/>' +
      '</svg>' +
      '<span>' + this.escHtml(code) + '</span>' +
      amountStr +
      '<button type="button" class="cart-extras__coupon-remove" data-remove-coupon="' + this.escAttr(code) + '" aria-label="Remover cupom ' + this.escAttr(code) + '">' +
        '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
          '<line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>' +
        '</svg>' +
      '</button>' +
    '</div>';
  }

  applyCoupon() {
    var code = (this.couponInput.value || '').trim();
    if (!code) return;

    var self = this;
    this.setLoading(this.couponBtn, true);
    this.couponResult.hidden = true;

    var discountBefore = 0;

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cartBefore) {
        discountBefore = cartBefore.total_discount || 0;
        return fetch('/discount/' + encodeURIComponent(code));
      })
      .then(function () {
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cartAfter) {
        var apps = cartAfter.cart_level_discount_applications || [];
        var found = null;
        var codeLower = code.toLowerCase();

        for (var i = 0; i < apps.length; i++) {
          if ((apps[i].title || '').toLowerCase() === codeLower) {
            found = apps[i];
            break;
          }
        }

        var applied = false;

        if (found && found.total_allocated_amount > 0) {
          applied = true;
        } else if (cartAfter.total_discount > discountBefore) {
          applied = true;
        }

        if (applied) {
          self.saveCoupon(code);
          /* Limpar flag de remoção — cupom novo aplicado */
          try { sessionStorage.removeItem('dream_discount_removed'); } catch (e) {}
          self.syncFooter(cartAfter);
          self.showAppliedCoupons(cartAfter);
          self.couponInput.value = '';
          /* Atualizar o drawer para refletir preços nos itens */
          if (typeof halo !== 'undefined' && halo.updateSidebarCart) {
            halo.updateSidebarCart(cartAfter);
          }
        } else {
          fetch('/discount/');
          self.showResult(
            self.couponResult,
            'Cupom inválido ou não aplicável a este pedido.',
            'error'
          );
        }

        self.setLoading(self.couponBtn, false, self._cpnLabel);
      })
      .catch(function () {
        self.showResult(self.couponResult, 'Erro ao aplicar cupom. Tente novamente.', 'error');
        self.setLoading(self.couponBtn, false, self._cpnLabel);
      });
  }

  removeCoupon(code) {
    /* Shopify não tem API AJAX para remover desconto.
       Marcamos como removido localmente e mascaramos os valores no footer.
       O desconto é efetivamente removido ao ir para o checkout via ?discount= */
    try {
      sessionStorage.setItem('dream_discount_removed', 'true');
      sessionStorage.removeItem('dream_coupon');
    } catch (e) {}

    /* Esconder a tag do cupom imediatamente */
    if (this.couponResult) this.couponResult.hidden = true;

    /* Re-sincronizar footer com os valores mascarados */
    var self = this;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { self.syncFooter(cart); })
      .catch(function () {});
  }

  /* ═══ Footer sync — subtotal + desconto + frete ═══ */
  syncFooter(cart) {
    var footer = document.querySelector('[data-cart-drawer-footer]');
    if (!footer) return;

    var subtotalEl = footer.querySelector('[data-cart-subtotal]');
    var discountEl = footer.querySelector('[data-cart-discount]');
    var shippingEl = footer.querySelector('[data-cart-shipping]');
    var totalEl    = footer.querySelector('[data-cart-total]');

    var subtotal = cart.original_total_price || cart.total_price;
    var discount = cart.total_discount || 0;
    var totalPrice = cart.total_price || 0;

    /* Se o desconto foi removido localmente, mascarar valores */
    var discountRemoved = sessionStorage.getItem('dream_discount_removed') === 'true';
    if (discountRemoved) {
      discount = 0;
      totalPrice = subtotal;
    }

    /* Subtotal — só mostrar se diferente do total (tem desconto) */
    var subtotalRow = footer.querySelector('.cart-drawer__subtotal-row');
    if (subtotalRow) {
      if (subtotal !== totalPrice) {
        subtotalRow.hidden = false;
        if (subtotalEl) subtotalEl.innerHTML = this.fmtMoney(subtotal);
      } else {
        subtotalRow.hidden = true;
      }
    }

    /* Linha de desconto — mostrar/esconder */
    var discountRow = footer.querySelector('.cart-drawer__discount-row');
    if (discountRow) {
      if (discount > 0) {
        discountRow.hidden = false;
        if (discountEl) discountEl.innerHTML = '-' + this.fmtMoney(discount);
        var apps = cart.cart_level_discount_applications || [];
        var namesEl = footer.querySelector('[data-cart-discount-names]');
        if (namesEl && apps.length) {
          namesEl.innerHTML = apps.map(function (d) {
            return '<span class="cart-drawer__discount-name">' +
              '<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true">' +
                '<path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/>' +
                '<line x1="7" y1="7" x2="7.01" y2="7"/>' +
              '</svg> ' + d.title +
            '</span>';
          }).join('');
          namesEl.hidden = false;
        }
      } else {
        discountRow.hidden = true;
      }
    }

    /* Frete no footer */
    this.refreshFooterShipping();

    /* Total final = cart total + frete estimado */
    var shippingCents = this.getShippingCents();
    var displayTotal = totalPrice + shippingCents;
    if (totalEl) {
      totalEl.setAttribute('data-cart-total-cents', totalPrice);
      totalEl.innerHTML = this.fmtMoney(displayTotal);
    }

    /* Legacy compat — hidden div inside AJAX zone */
    var legacyVal = document.querySelector('[data-cart-info-legacy] [data-cart-total-value]');
    if (legacyVal) {
      legacyVal.setAttribute('data-cart-total-value', totalPrice);
      legacyVal.innerHTML = this.fmtMoney(totalPrice);
    }
  }

  /* ═══ Helpers ═══ */

  showResult(el, html, type) {
    el.innerHTML = html;
    el.className = 'cart-extras__result cart-extras__result--' + type;
    el.hidden = false;

    /* Bind remove buttons se presentes */
    var self = this;
    el.querySelectorAll('[data-remove-coupon]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        self.removeCoupon(btn.getAttribute('data-remove-coupon'));
      });
    });
  }

  setLoading(btn, on, label) {
    if (!btn) return;
    if (on) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.innerHTML = '<span class="cart-extras__spinner"></span>';
    } else {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      btn.textContent = label || '';
    }
  }

  fmtMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, window.money_format);
    }
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');
  }

  escHtml(s) {
    var d = document.createElement('div');
    d.textContent = s;
    return d.innerHTML;
  }

  escAttr(s) {
    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }
}

customElements.define('dream-cart-extras', DreamCartExtras);
